import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PlayList() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="playlist" ref={ref} className="relative py-24 md:py-32 overflow-hidden">
      {/* Silk texture background — same as Works */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Luxurious%20silk%20fabric%20texture%20background%2C%20soft%20flowing%20pink%20and%20champagne%20gold%20folds%2C%20elegant%20draped%20satin%2C%20gentle%20curves%20and%20waves%2C%20warm%20ivory%20undertones%2C%20refined%20and%20sophisticated%2C%20editorial%20luxury%20aesthetic%2C%20high-end%20fashion%20photography%20style%2C%20soft%20diffused%20lighting%2C%20seamless%20silk%20backdrop&width=1600&height=900&seq=hero-silk-bg&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-warm-ivory/60"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-warm-ivory/30 via-transparent to-warm-ivory/40"></div>

      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-300/40 to-transparent"></div>

      <div className="relative max-w-6xl mx-auto px-6 md:px-8">
        {/* Header */}
        <div className={`mb-12 md:mb-16 text-center ${isVisible ? 'reveal revealed' : 'reveal'}`}>
          <p className="text-[10px] tracking-[0.3em] text-gold-500 uppercase mb-4 font-medium">ミュージック</p>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-charcoal-800 tracking-tight">
            Play List
          </h2>
        </div>

        {/* Spotify Embed */}
        <div className={`max-w-3xl mx-auto ${isVisible ? 'reveal revealed' : 'reveal'} reveal-delay-1`}>
          <div className="relative bg-white ring-1 ring-gold-200/40 overflow-hidden hover:ring-gold-300/60 transition-all duration-500">
            {/* Spotify iframe */}
            <div className="w-full">
              <iframe
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                className="w-full"
                height="380"
                loading="lazy"
                src="https://open.spotify.com/embed/playlist/4NIBk1d8MZ4wqHOHlNDYLF?utm_source=generator&theme=0"
                style={{ border: 'none' }}
                title="TSINGTAO_Works Spotify Playlist"
              ></iframe>
            </div>
          </div>

          {/* Playlist description */}
          <p className={`text-center text-sm text-charcoal-800 mt-8 leading-relaxed font-medium ${isVisible ? 'reveal revealed' : 'reveal'} reveal-delay-2`}>
            制作した楽曲をまとめたプレイリスト。Spotifyで是非お聴きください。
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-300/40 to-transparent"></div>
    </section>
  );
}